import React, { useState, useEffect, useContext } from "react";
import {SelectPanel} from "react-multi-select-component";
import Button from 'react-bootstrap/Button';
import { LabelText } from '../../Language/LabelText';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import './MultiSelect.css';
 
function MultiSelect(props) {
  const options = props.options() ? props.options() : [];
  const columnFilteredOptions = props.columnFilterOptions && props.columnFilterOptions.size > 0
                                && props.columnFilterOptions.has(props.column.columnIndex)
                                && props.columnFilterOptions.get(props.column.columnIndex).length > 0
                                ? props.columnFilterOptions.get(props.column.columnIndex) : [];
  const [selected, setSelected] = useState(columnFilteredOptions);
  const [prevSelected, setPrevSelected] = useState([]);
  const [appliedOptions, setAppliedOption] = useState([]);
  const languageContext = useContext(LanguageContext);
  const [isSearchRemoved, setIsSearchRemoved] = useState(false);

  const handlerOnSelected = (values) => {
    const isItemSelected = values && values.length > 0;
    setPrevSelected( isItemSelected ? appliedOptions : []);
    setSelected(values);
  }

  const handlerOnFilter = (ev) => {
    let data = props.data && props.data.length > 0 ? props.data : [];
    const isItemSelected = selected && selected.length > 0;
    setAppliedOption(isItemSelected ? selected: []);
    if (isItemSelected) {
      const selectedFilterValue = selected.map(d=>d.value);
      data = !props.isNestedArray ? data.filter(item=> selectedFilterValue.includes(!props.nestedObjectField ? 
                props.isDropdown ? languageContext.labels[(item[props.field]).toLowerCase()] :
                props.isRuleValue ? languageContext.labels[(item[props.field])] : item[props.field]
                : props.isRuleValue ? languageContext.labels[item[props.nestedObjectField][props.field]]   
                : item[props.nestedObjectField][props.field]))
            : (data.filter(item=>item[props.nestedObjectField]
                   .some(el=>selectedFilterValue.includes(props.isRuleValue ? languageContext.labels[(el[props.field])] : el[props.field])))
                   .map(bp=> {
                    return {
                      ...bp,
                      [props.nestedObjectField]: bp[props.nestedObjectField]
                                                .filter(cd=>selectedFilterValue
                                                .includes(props.isRuleValue ? languageContext.labels[(cd[props.field])] 
                                                : cd[props.field]))
                    }
                })
            );  
    } 
    props.getSelectedColumnFilterIndexes(props.column.columnIndex, isItemSelected);
    setAppliedOption(selected);
    props.getColumnFilterOptions(props.column.columnIndex, isItemSelected, selected);
    props.onFilter(data);
    props.closePopoverHandler(ev, props.column.columnIndex);
    if (props.isOverviewColumnFilter) {
      props.handlerCheckDetailsFilterApplied(isItemSelected, data, props.columnFilterIndexes);
    } else {
      props.handlerCheckDetailsFilterApplied(isItemSelected, data);
    }
  }

  const handlerOnCancel = (ev) => {
    const itemSelected = prevSelected && prevSelected.length > 0 ? prevSelected : [];
    setSelected(itemSelected);
    props.closePopoverHandler(ev, props.column.columnIndex);
  }

  const customFilterOptionsSearch = (filterOptions, filter) => {
    if (!filter) {
      setIsSearchRemoved(true);
      return filterOptions;
    }
    const re = props.IsDate ? new RegExp(filter, "/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/g")
        : null;
    const opt = filterOptions.filter(({ value }) => value ? props.IsDate ? value.match(re) : value.toLowerCase().includes(filter.toLowerCase()) : value);
    
    return opt;
  }

  useEffect(() => {
      let searchBoxAll = document.querySelectorAll(".select-panel div input[type=text]");
      if(searchBoxAll  && searchBoxAll.length > 0) {
        const searchLabelText = languageContext.labels['search'];
        if(searchLabelText) {
          searchBoxAll.forEach(searchBox => searchBox.setAttribute("placeholder", searchLabelText));        
        }
      }

      let selectAllCheckBoxAll = document.querySelectorAll(".select-panel label div input[type=checkbox]");
      if(selectAllCheckBoxAll && selectAllCheckBoxAll.length > 0) {
        selectAllCheckBoxAll.forEach(selectAllCheckBox => selectAllCheckBox.setAttribute("tabindex", "0"));        
      }

      let selectAllCheckBoxTextAll = document.querySelectorAll(".select-panel div + label div span");
      if(selectAllCheckBoxTextAll && selectAllCheckBoxTextAll.length > 0) {
        selectAllCheckBoxTextAll.forEach(selectAllCheckBoxText => selectAllCheckBoxText.textContent 
          = languageContext.labels['select_all']);        
      }

      let itemCheckBoxAll = document.querySelectorAll(".select-panel ul label input[type=checkbox]");
      if(itemCheckBoxAll && itemCheckBoxAll.length > 0) {
        itemCheckBoxAll.forEach(itemCheckBox => itemCheckBox.setAttribute("tabindex", "0"));
      }
  }, []);

  useEffect(() => {
    if(options && options.length > 0) {
      let selectAllCheckBox = document.querySelector(".select-panel div + label div input[type=checkbox]");
      if(selectAllCheckBox) {
        const isIndeterminate = selected && selected.length > 0 && selected.length !== options.length;
        selectAllCheckBox.indeterminate = isIndeterminate;
        selectAllCheckBox.checked = isIndeterminate ? false : selectAllCheckBox.checked;
      }
    }
    setIsSearchRemoved(false);
  }, [selected, isSearchRemoved]);   

  useEffect(() => {
    let searchBoxAll = document.querySelectorAll(".select-panel div input[type=text]");
    if(searchBoxAll  && searchBoxAll.length > 0) {
      const searchLabelText = languageContext.labels['search'];
      if(searchLabelText) {
        searchBoxAll.forEach(searchBox => searchBox.setAttribute("placeholder", searchLabelText));        
      }
    }

    let selectAllCheckBoxTextAll = document.querySelectorAll(".select-panel div + label div span");
    if(selectAllCheckBoxTextAll && selectAllCheckBoxTextAll.length > 0) {
      selectAllCheckBoxTextAll.forEach(selectAllCheckBoxText => selectAllCheckBoxText.textContent 
        = languageContext.labels['select_all']);        
    }
  }, [languageContext && languageContext.language.id]);

  return (
      <div tabIndex="0">
      <SelectPanel
        tabIndex="0"
        options={options}
        value={selected}
        onChange={(v)=>handlerOnSelected(v)}
        hasSelectAll={options && options.length > 0}
        focusSearchOnOpen={true}
        filterOptions={customFilterOptionsSearch}
        onMenuToggle={false}
      />
      <div >
          <Button variant="primary" className="ok-btn" tabIndex="0" size="sm" onClick={(ev)=> {ev.stopPropagation(); handlerOnFilter(ev)}} 
          disabled={!(selected && selected.length > 0)}>
              <LabelText tid="ok" />
          </Button>&nbsp;
          <Button variant="secondary" tabIndex="0" size="sm" onClick={(ev)=> {ev.stopPropagation();handlerOnCancel(ev)}}>
                  <LabelText tid="cancel" />
          </Button>
      </div>
    </div>
  );
}

export default MultiSelect;
